// extracted by mini-css-extract-plugin
export default {"tabs":"SearchTypeTab_tabs__Tz0zi","tab":"SearchTypeTab_tab__9AF47","title":"SearchTypeTab_title__NZHp+","underline":"SearchTypeTab_underline__1hc4l"};